import React from "react";
import PropTypes from "prop-types";
import Button from "../../components/button";

const WoEligibilityContainer = ({ classOption = "mt-10 mt-lg-0" }) => {
    return (
        <div className={`funfact-section position-relative   ${classOption}`}>
            <div className="y-background-color py-5">
                <div className="container">
                    <div className="row mb-5 ">
                        <div className="col-xl-12 col-lg-12 mx-auto text-center">
                            <div className="title-section title-section text-center ">
                                <h4 className="font-weight-bold g-color">
                                    <b>Eligibility Criteria</b>
                                </h4>
                                <h4 className="font-weight-bold b-color mt-4">
                                    <b>
                                        Woman who are currently not employed can
                                        apply
                                    </b>
                                </h4>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-n7 text-center">
                        <div className="col-md-12 col-12 mb-7">
                            <div className="fanfact text-md-left text-center">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/images/career/womancareer/desk-Infographics.png"
                                    }
                                    alt="images"
                                    width={"50%"}
                                    className="item-mobile"
                                />
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/images/career/womancareer/desk-Infographics-i1.png"
                                    }
                                    alt="images"
                                    width={"40%"}
                                    className="item-desk"
                                />
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/images/career/womancareer/desk-Infographics-i2.png"
                                    }
                                    alt="images"
                                    width={"10%"}
                                    className="item-desk"
                                />
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/images/career/womancareer/desk-Infographics-i3.png"
                                    }
                                    alt="images"
                                    width={"40%"}
                                    className="item-desk"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" py-5">
                <div className="container">
                    <div className="row mb-5 ">
                        <div className="col-xl-12 col-lg-12 mx-auto text-center">
                            <div className="title-section title-section text-center ">
                                <h4 className="font-weight-bold g-color">
                                    <b>Highlights</b>
                                </h4>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-n7 text-center justify-content-center mt-5">
                        <div className="col-xl-4 col-lg-4 col-md-6 col-12 mb-7">
                            <div className="g-background-color radius-box p-3">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/images/career/womancareer/highlight1.png"
                                    }
                                    alt="images"
                                    width={"20%"}
                                />
                                <p className="b-color mt-5">
                                    Robust Learning <br />& Development Program
                                </p>
                            </div>
                        </div>

                        <div className="col-xl-4 col-lg-4 col-md-6 col-12 mb-7">
                            <div className="g-background-color radius-box p-3">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/images/career/womancareer/highlight2.png"
                                    }
                                    alt="images"
                                    width={"20%"}
                                />
                                <p className="b-color mt-5">
                                    Certified great <br />
                                    place to work with
                                </p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-12 mb-7">
                            <div className="g-background-color radius-box p-3">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/images/career/womancareer/highlight3.png"
                                    }
                                    alt="images"
                                    width={"20%"}
                                />
                                <p className="b-color mt-5">
                                    Inclusion is in <br />
                                    our DNA
                                </p>
                            </div>
                        </div>

                        <div className="col-xl-4 col-lg-4 col-md-6 col-12 mb-7">
                            <div className="g-background-color radius-box p-3">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/images/career/womancareer/highlight4.png"
                                    }
                                    alt="images"
                                    width={"20%"}
                                />
                                <p className="b-color mt-5">
                                    Hand-Holding for <br />
                                    smooth reintegration
                                </p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-12 mb-7">
                            <div className="g-background-color radius-box p-3">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/images/career/womancareer/highlight5.png"
                                    }
                                    alt="images"
                                    width={"20%"}
                                />
                                <p className="b-color mt-5">
                                    Emphasis on <br />
                                    Diversity
                                </p>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-12 mb-7">
                            <div className="g-background-color radius-box p-3">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/images/career/womancareer/highlight6.png"
                                    }
                                    alt="images"
                                    width={"20%"}
                                />
                                <p className="b-color mt-5">
                                    Women centric <br />
                                    policies and benefits
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" y-background-color py-5">
                <div className="container">
                    <div className="row mb-5 ">
                        <div className="col-xl-12 col-lg-12 mx-auto text-center">
                            <div className="title-section title-section text-center ">
                                <h4 className="font-weight-bold g-color">
                                    <b>We are Looking for</b>
                                </h4>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-n7 text-center">
                        <div className="col-md-12 col-12 mb-7">
                            <div className="fanfact text-md-left text-center">
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/images/career/womancareer/desk-Infographics-2.png"
                                    }
                                    alt="images"
                                    width={"60%"}
                                    className="item-mobile"
                                />
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/images/career/womancareer/desk-Infographics-2.png"
                                    }
                                    alt="images"
                                    width={"100%"}
                                    className="item-desk"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" my-5">
                <div className="container">
                    <div className="row mb-5 ">
                        <div className="col-xl-12 col-lg-12 mx-auto text-center">
                            <div className="title-section title-section text-center ">
                                <h4 className="font-weight-bold g-color">
                                    <b>Join Our Team Now</b>
                                </h4>
                            </div>
                        </div>
                    </div>
                    <div className="text-center">
                        <Button
                            classOption="btn btn-sm btn-primary btn-hover-primary mt-5"
                            text="Apply"
                            path={"/job-apply/second-career-for-women"}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

WoEligibilityContainer.propTypes = {
    classOption: PropTypes.string,
};

export default WoEligibilityContainer;
